module.exports = __webpack_public_path__ + "static/media/Planning-Inspiration@shortened.d79a59d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/Planning-Inspiration@shortened.gif
// module id = 115
// module chunks = 0